<div fxLayout="column" fxLayoutAlign="start center" class="navbar-content">
  <!-- <img src="https://mg.mitrix.com.br/img/logo.png" alt="MSys" height="50"> -->
  <h2 class="title text-green">MHelp</h2>

  <div class="user text-center">
    <img class="avatar" [src]="userAvatar">
    <h4 class="text-hard-blue">{{ user.name }}</h4>
    <h6 class="text-red">Sair</h6>
  </div>

  <nav class="nav">
    <ul class="navbar">
      <li class="navbar-item">
        <a class="navbar-item-link" routerLinkActive="actived" [routerLinkActiveOptions]="{exact: true}" routerLink="/operador">
          <mat-icon class="navbar-item-icon">home</mat-icon>
          <span class="navbar-item-text">Início</span>
        </a>
      </li>

      <li class="navbar-item">
        <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/chamados">
          <mat-icon class="navbar-item-icon">support</mat-icon>
          <span class="navbar-item-text">Chamados</span>
        </a>
      </li>

      <li class="navbar-item">
        <mat-expansion-panel hideToggle class="navbar-item mat-elevation-z0 body-p0">
          <mat-expansion-panel-header class="navbar">
              <a class="navbar-item-link a-size">
                <mat-icon class="navbar-item-icon">perm_contact_calendar</mat-icon>
                <span class="navbar-item-text contacts-text">Contatos</span>
              </a>
          </mat-expansion-panel-header>
            <ul class="navbar">
              <mat-divider></mat-divider>
              <li class="navbar-item">
                <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/empresas">
                  <mat-icon class="navbar-item-icon">business</mat-icon>
                  <span class="navbar-item-text">Empresas</span>
                </a>
              </li>
              <mat-divider></mat-divider>
              <li class="navbar-item">
                <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/usuarios">
                  <mat-icon class="navbar-item-icon">supervisor_account</mat-icon>
                  <span class="navbar-item-text">Usuários</span>
                </a>
              </li>
            </ul>
        </mat-expansion-panel>
      </li>

      <!-- <li class="navbar-item">
        <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/base">
          <mat-icon class="navbar-item-icon">feed</mat-icon>
          <span class="navbar-item-text">Base</span>
        </a>
      </li> -->

      <!-- <li class="navbar-item">
        <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/relatorios">
          <mat-icon class="navbar-item-icon">flag</mat-icon>
          <span class="navbar-item-text">Relatórios</span>
        </a>
      </li>

      <li class="navbar-item">
        <a class="navbar-item-link" routerLinkActive="actived" routerLink="/operador/configuracoes">
          <mat-icon class="navbar-item-icon">settings</mat-icon>
          <span class="navbar-item-text">Configurações</span>
        </a>
      </li> -->
    </ul>
  </nav>
</div>
